// extracted by mini-css-extract-plugin
export default {"container":"style_container__9HgVi","header":"style_header__x2s+u","content":"style_content__SNaRb","areas":"style_areas__6bt1y","TOP":"style_TOP__xUcjG"};